import React from 'react';
import { Trash2, X, CheckSquare, Square } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export default function BatchActionBar({
  isSelectionMode,
  selectedCount,
  totalCount,
  onSelectAll,
  onClearSelection,
  onBatchDelete,
  isDeleting,
  className,
  children
}) {
  if (!isSelectionMode) return null;

  const allSelected = selectedCount === totalCount && totalCount > 0;

  return (
    <div className={cn(
      "fixed top-4 left-1/2 -translate-x-1/2 z-[100] w-[90%] max-w-2xl bg-white/95  shadow-[0_10px_40px_rgba(0,0,0,0.1)] border border-slate-200/60 rounded-2xl p-3 flex items-center justify-between transition-all animate-in slide-in-from-top-4 fade-in duration-300",
      className
    )}>
      <div className="flex items-center gap-4 pl-2">
        <button 
          onClick={onSelectAll}
          className="flex items-center gap-2 text-sm font-bold text-slate-700 hover:text-slate-900 transition-colors"
        >
          {allSelected ? (
            <CheckSquare className="w-5 h-5 text-rose-600" />
          ) : (
            <Square className="w-5 h-5 text-slate-400" />
          )}
          <span className="hidden sm:inline">Pilih Semua</span>
        </button>
        <div className="h-6 w-px bg-slate-200 mx-1"></div>
        <span className="text-sm font-black text-rose-600 bg-rose-50 px-3 py-1 rounded-lg border border-rose-100">
          {selectedCount} Terpilih
        </span>
      </div>
      
      <div className="flex items-center gap-2">
        {children}
        <Button 
          onClick={onBatchDelete}
          disabled={isDeleting || selectedCount === 0}
          className="bg-rose-600 hover:bg-rose-700 text-white font-bold gap-2 rounded-xl h-9 px-4 shadow-sm ml-2"
        >
          <Trash2 className="w-4 h-4" /> 
          <span className="hidden sm:inline">Hapus Data</span>
        </Button>
        <Button 
          onClick={onClearSelection}
          disabled={isDeleting}
          variant="ghost"
          size="icon"
          className="h-9 w-9 rounded-xl hover:bg-slate-100 text-slate-500"
        >
          <X className="w-5 h-5" />
        </Button>
      </div>
    </div>
  );
}
